import { EventEmitter } from "events"
import dispatcher from "../dispatcher"

class DeviceStore extends EventEmitter {
    constructor() {
        super()
        this.setMaxListeners(0)
        this.devices = []
        this.totalCount = 0
        this.page = 0
        this.limitOption = [20, 50, 100]
        this.limit = this.limitOption[0]
        this.search = ""
    }

    setDevices(data) {
        this.devices = data.documents
        this.totalCount = data.totalDocumentCount
        if (data.page !== null) this.page = data.page
        if (data.limit) this.limit = data.limit
        this.search = data.search
        this.emit("change")
    }

    setFilter(data) {
        this.search = data
        this.emit("change")
    }

    getDevices() {
        return this.devices
    }

    getPage() {
        return this.page
    }

    getLimit() {
        return this.limit
    }

    getLimitOption() {
        return this.limitOption
    }

    getSearch() {
        return this.search
    }

    getTotalDeviceCount() {
        return this.totalCount
    }

    handleActions(action) {
        switch (action.type) {
            case "GET_TOPLEVEL_DEVICES": {
                this.setDevices(action.data)
                break
            }
            case "UPDATE_TOPLEVEL_DEVICES_FILTER_TEXT": {
                this.setFilter(action.data)
                break
            }
        }
    }
}

const deviceStore = new DeviceStore()
dispatcher.register(deviceStore.handleActions.bind(deviceStore))

export default deviceStore
